import { render, staticRenderFns } from "./MoveToStageOptions.vue?vue&type=template&id=0ad45f82"
import script from "./MoveToStageOptions.vue?vue&type=script&lang=js"
export * from "./MoveToStageOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports